import { FC } from 'react';
import { cx } from '@/utils/cx';

export type CardDividerProps = {
  className?: string;
};

export const CardDivider: FC<CardDividerProps> = ({ className }) => (
  <div
    className={cx(
      'mt-7 -mr-8 mb-6 -ml-10 h-px border-b border-gray-900/10',
      className,
    )}
  ></div>
);
